(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsAppointmentTypeController', ['$state', '$uibModal', 'AppointmentType', 'SharedAgendaService', 'PaginationService', 'appointmenttypes', AgendaSettingsAppointmentTypeControllerFn]);

    /* controlle for main agenda-settings appointment types */
    function AgendaSettingsAppointmentTypeControllerFn($state, $uibModal, AppointmentType, SharedAgendaService, PaginationService, appointmenttypes) {
        var vm = this;

        // overview service
        vm.overview = null;

        // start
        activate();

        /* show all types (includes deactivated ones) */
        vm.showAll = function () {
            $state.go($state.current.name, { all: vm.overview.data.showAll }, { reload: $state.current.name });
        };

        /* new appointment type */
        vm.new = function () {
            // modal 
            var modalInstance = null;

            // open modal
            modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/agendasettings/modules/appointmenttypes/templates/appointment-type-detail.template.html',
                controller: 'DetailAppointmentTypeController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    type: function () {
                        var type = new AppointmentType();
                        type.extend(type);
                        // set agenda
                        type.fK_Agenda = SharedAgendaService.currentUser().agendaId;
                        type.videoconsultsActivatedInAgenda = SharedAgendaService.data.currentAgenda.videoconsultsActivated;
                        type.ibanNumberOfOwner = SharedAgendaService.data.currentAgenda.owner.ibanNumber;
                        return type;
                    },
                    colors: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.colors();
                    }],
                    languages: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.languages();
                    }],
                    agendalabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                        return AgendaLabelService.query(SharedAgendaService.currentUser().agendaId, false);
                    }]                    
                }
            });

            // when modal is closed
            modalInstance.result.then(function (item) {
                // push to array
                var type = new AppointmentType();
                type.extend(item);
                vm.overview.add(type);
            }, function () {
                //dismissed
            });
        };

        /* activation work */
        function activate() {
            var array = [];
            // list of appointment types
            appointmenttypes.forEach(function (item) {
                var type = new AppointmentType();
                type.extend(item);

                //push to array
                array.push(type);
            });

            // init overview Service
            vm.overview = new PaginationService(array);

            // clear
            appointmenttypes = null;

        }
    }
})();
